// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rXpX","newExpiryDate":"styles_newExpiryDate__zxBh_","footer":"styles_footer__3FraP"};